// Joya Headquarter — data, settings, menu and employee strings (English). Same keys in data.he.js and data.en.js.
export default {
  "joya.data.title": "Data sources & quality",
  "joya.data.kind.SALES_CHECKS": "Checks (diners and orders)",
  "joya.data.kind.SALES_ITEMS": "Sales by item",
  "joya.data.kind.EMPLOYEES": "Employees",
  "joya.data.kind.ATTENDANCE": "Attendance",
  "joya.data.kind.PAYROLL": "Payroll lines",
  "joya.data.kind.INQUIRIES": "Inquiries & reviews",
  "joya.data.sub": "What is missing, old or not mapped — per location. A missing value is not counted as zero.",
  "joya.data.integrations": "Connections to other systems",
  "joya.data.noLive": "Sales, clock times, employees and payroll are read from the Allegro admin API. Nothing of it is copied here.",
  "joya.data.notConnected": "not connected",
  "joya.data.method.FILE_IMPORT": "file import",
  "joya.data.method.MANUAL": "manual entry",
  "joya.data.kinds": "Data types",
  "joya.data.cred.set": "credentials: set in the server env",
  "joya.data.cred.notSet": "credentials: not set",
  "joya.data.exportOnly": "export only: {what}",
  "joya.data.sources": "Data sources",
  "joya.data.lastData": "last data",
  "joya.data.lastPeriod": "last month",
  "joya.data.rows": "rows",
  "joya.data.noRows": "no data",
  "joya.data.stale": "not up to date",
  "joya.data.issues": "Problems found",
  "joya.data.noIssues": "No problems found.",
  "joya.data.sev.HIGH": "important",
  "joya.data.sev.MEDIUM": "medium",
  "joya.data.sev.LOW": "low",
  "joya.data.sev.INFO": "for information",
  "joya.data.goMenu": "Open the menu",
  "joya.data.goEmployees": "Open employees",
  "joya.data.goRules": "Open shift settings",
  "joya.data.goImport": "Open import",
  "joya.data.issue.NO_SALES_CHECKS": "Allegro has no Beecomm orders for this branch.",
  "joya.data.issue.STALE_SALES": "Beecomm orders in Allegro have not been updated for {days} days.",
  "joya.data.issue.NO_SALES_ITEMS": "Allegro has no dish sales for this branch.",
  "joya.data.issue.STALE_SALES_ITEMS": "Dish sales in Allegro have not been updated for {days} days.",
  "joya.data.issue.MISSING_SALES_DAYS": "{count} days in the last 28 days have no sales in Beecomm — days the restaurant was closed (checked up to the last day Allegro loaded).",
  "joya.data.issue.CHECKS_WITHOUT_DINERS": "{count} of {of} checks have no diner count.",
  "joya.data.issue.CHECKS_WITHOUT_CLOSE_TIME": "{count} of {of} checks have no close time (needed for diners seated at once).",
  "joya.data.issue.CHECKS_WITHOUT_AMOUNT": "{count} of {of} checks have no amount.",
  "joya.data.issue.UNMATCHED_ITEM_CODES": "{count} dishes sold in the last 28 days are not on the menu here.",
  "joya.data.issue.NO_MENU": "This location has no menu in the system.",
  "joya.data.issue.DISHES_WITHOUT_INGREDIENTS": "{count} of {of} dishes have no ingredient list.",
  "joya.data.issue.RECIPE_LINES_WITHOUT_QTY": "{count} dish ingredients have no quantity. This is allowed — quantities are optional.",
  "joya.data.issue.NO_ATTENDANCE": "Allegro has no Tabit clock rows for this branch. Upload the Tabit detailed report in Allegro.",
  "joya.data.issue.STALE_ATTENDANCE": "The Tabit clock rows in Allegro are {days} days old.",
  "joya.data.issue.UNMATCHED_EMPLOYEE_IDS": "Allegro could not match some Tabit names to one employee. Their hours count for no one.",
  "joya.data.issue.ATTENDANCE_WITHOUT_ROLE": "{count} clock rows have a role name with no Joya role (last 28 days).",
  "joya.data.issue.NO_SHIFTS_DEFINED": "No shifts are defined for this location — staffing cannot be planned.",
  "joya.data.issue.NO_PAYROLL": "Allegro has no saved payroll month for this branch.",
  "joya.set.title": "Settings",
  "joya.set.tabUsers": "Users & access",
  "joya.set.tabLocations": "Locations",
  "joya.set.tabNumbers": "Numbers the system uses",
  "joya.set.tabIntegrations": "Connections & credentials",
  "joya.set.allegroRole": "Allegro role",
  "joya.set.inactiveAllegro": "not active",
  "joya.set.noAccess": "No access",
  "joya.set.usersIntro": "Users and their rights are set only in the Allegro admin (same e-mail and password). An Allegro admin is a chain admin here, and a restaurant manager sees their own branches. To add or change a user, do it in the Allegro admin.",
  "joya.set.locations": "Locations",
  "joya.set.allLocations": "all locations",
  "joya.set.payroll": "Payroll access",
  "joya.set.yes": "yes",
  "joya.set.no": "no",
  "joya.set.noUsers": "There are no users in the Allegro admin.",
  "joya.set.adminOnly": "Only chain management can change this.",
  "joya.set.code": "Code",
  "joya.set.codeHint": "Latin letters, digits, - and _. Imports use the code, not the name.",
  "joya.set.name": "Name",
  "joya.set.active": "Active",
  "joya.set.inactive": "inactive",
  "joya.set.addLocation": "New location",
  "joya.set.editLocation": "Edit location",
  "joya.set.numbersIntro": "Every number the recommendations use is shown here. A change affects new recommendations only.",
  "joya.set.readOnly": "Read only — only chain management changes these.",
  "joya.set.saved": "Saved",
  "joya.set.badNumber": "Must be a number of 0 or more",
  "joya.set.group.replenishment": "Ordering & replenishment",
  "joya.set.group.staffing": "Shift planning",
  "joya.set.group.labor": "Labor cost",
  "joya.set.group.dataQuality": "Data quality",
  "joya.set.k.historyLists": "Past lists to learn from",
  "joya.set.h.historyLists": "How many of the latest final lists of the location are used.",
  "joya.set.k.halfLifeLists": "Half-life (in lists)",
  "joya.set.h.halfLifeLists": "After how many lists an older list weighs half as much.",
  "joya.set.k.minExamplesForQty": "Minimum lists for a quantity",
  "joya.set.h.minExamplesForQty": "Fewer than this — no quantity is suggested; the manager fills it in.",
  "joya.set.k.minExamplesForRatio": "Minimum lists for the sales ratio",
  "joya.set.h.minExamplesForRatio": "How many orders with complete sales data are needed to use the quantity/sales ratio.",
  "joya.set.k.dueFraction": "Part of the usual gap",
  "joya.set.h.dueFraction": "An item is due when this part of its usual gap between orders has passed (0.8 = 80%).",
  "joya.set.k.shortageBumpPct": "Increase after a shortage (%)",
  "joya.set.h.shortageBumpPct": "How much to raise the quantity when a shortage was reported since the last order.",
  "joya.set.k.removedSuppressShare": "Removal share",
  "joya.set.h.removedSuppressShare": "If the manager removed a suggested item in this share of lists, it moves to \"check\".",
  "joya.set.k.approvedOnlyWeight": "Weight of an approved list not marked as ordered",
  "joya.set.h.approvedOnlyWeight": "A list that was really ordered weighs 1.",
  "joya.set.k.coldStartDays": "Days used with no history",
  "joya.set.h.coldStartDays": "With no past lists: how many recent sales days are shown as information.",
  "joya.set.k.historyWeeks": "Weeks of history for the forecast",
  "joya.set.h.historyWeeks": "The forecast is the median of the same weekday over these weeks.",
  "joya.set.k.minDaysForForecast": "Minimum days for a forecast",
  "joya.set.h.minDaysForForecast": "Fewer days with data — low confidence in the forecast.",
  "joya.set.k.learnedAdjustMinPlans": "Minimum plans to learn from edits",
  "joya.set.h.learnedAdjustMinPlans": "A change the manager made at least this many times, in the same direction, is shown as a learned adjustment.",
  "joya.set.k.learnedAdjustWindow": "Recent plans checked",
  "joya.set.h.learnedAdjustWindow": "How many recent approved plans are checked.",
  "joya.set.k.employerCostFactorEstimate": "Employer cost factor (estimate)",
  "joya.set.h.employerCostFactorEstimate": "Not used any more: the labor cost comes from the Allegro admin (its payroll rules).",
  "joya.set.k.staleDays": "Days until \"not up to date\"",
  "joya.set.h.staleDays": "Data not updated for more days than this is marked as not up to date.",
  "joya.set.k.longShiftHours": "Long shift (hours)",
  "joya.set.h.longShiftHours": "A shift longer than this is flagged in the payroll checks.",
  "joya.set.intText1": "Sales (Beecomm), clock times (Tabit), employees and payroll are read live from the Allegro admin API. Joya keeps none of it; answers are kept in memory for 5 minutes only.",
  "joya.set.intText2": "The API address is the server variable ALLEGRO_API_URL. The API answers only on its own machine, so joya-hq runs next to the Allegro admin (or through an SSH tunnel). Instagram and Google are still typed in by hand; their keys would go in the server environment file.",
  "joya.set.envName": "Server variable name",
  "joya.set.noEnv": "none yet",
  "joya.menu.title": "Menu & ingredients",
  "joya.menu.tabMenu": "Menu",
  "joya.menu.tabIngredients": "Ingredients",
  "joya.menu.addItem": "New dish",
  "joya.menu.editItem": "Edit dish",
  "joya.menu.code": "POS code",
  "joya.menu.codeHint": "POS sales are matched to the dish by this code, not by the name.",
  "joya.menu.name": "Name",
  "joya.menu.category": "Category",
  "joya.menu.active": "Active",
  "joya.menu.inactive": "inactive",
  "joya.menu.ingCount": "{count} ingredients, {noQty} without a quantity",
  "joya.menu.noIngList": "no ingredient list",
  "joya.menu.qtyOptional": "Ingredient quantities are optional. An ingredient without a quantity helps estimate demand but is not used for an \"exact\" consumption figure.",
  "joya.menu.recipe": "Dish ingredients",
  "joya.menu.ingredient": "Ingredient",
  "joya.menu.qty": "Quantity per dish",
  "joya.menu.qtyEmpty": "empty = not known",
  "joya.menu.unit": "Unit",
  "joya.menu.addLine": "Add ingredient",
  "joya.menu.search": "Search ingredient…",
  "joya.menu.newIngredient": "New ingredient",
  "joya.menu.noLines": "No ingredients for this dish yet.",
  "joya.menu.noItems": "No dishes for this location. You can import the menu from the POS.",
  "joya.menu.orderUnit": "Ordering unit",
  "joya.menu.dishes": "in dishes: {n}",
  "joya.menu.addIngredient": "New ingredient",
  "joya.menu.editIngredient": "Edit ingredient",
  "joya.menu.ingCode": "Code (optional)",
  "joya.menu.noIngredients": "No ingredients found.",
  "joya.menu.badQty": "Quantity must be a number above 0, or empty",
  "joya.menu.posItemsHint": "A POS item code that is not on the menu is listed on the data quality page.",
  "joya.emp.title": "Employees",
  "joya.emp.fromAllegro": "Employees come from the Allegro admin. Change them there; Joya only reads them.",
  "joya.emp.unmatchedTitle": "Clock rows without an employee",
  "joya.emp.unmatchedHelp": "Allegro could not match these Tabit names to one employee safely, so their hours are not counted for anyone. Fix the name or phone in Allegro.",
  "joya.emp.allMatched": "Every clock row of the last 35 days belongs to an employee.",
  "joya.emp.rowsCount": "{n} rows",
  "joya.emp.location": "Location",
  "joya.emp.role": "Role",
  "joya.emp.allegroRoles": "Roles in Allegro",
  "joya.emp.roleNotMapped": "not mapped — Settings → Roles",
  "joya.emp.wage": "Hourly wage (gross)",
  "joya.emp.inactive": "inactive",
  "joya.emp.contractor": "contractor",
  "joya.emp.noEmployees": "No employees in Allegro for these locations.",
  "joya.emp.filter": "Filter by name…",
  "joya.data.connected": "connected",
  "joya.data.method.API": "live API (read only)",
  "joya.data.goRoles": "Open role names",
  "joya.data.issue.ALLEGRO_UNREACHABLE": "The Allegro API cannot be reached, so no source data can be shown: {message}",
  "joya.data.issue.SOURCE_NOT_LOADED": "Allegro does not have this data yet ({source}): {reason}",
  "joya.data.issue.UNMAPPED_ROLE_NAMES": "Some role names from Allegro have no Joya role. Choose one in Settings → Roles.",
  "joya.set.locationsIntro": "Locations and companies come from Allegro (the admin's branch list); Joya does not store them. A new branch appears by itself. A branch with no Beecomm orders in the last 60 days (for example a closed branch) is marked inactive and hidden from the branch picker.",
  "joya.set.branchId": "Allegro branch id",
  "joya.set.refresh": "Read Allegro again now",
  "joya.set.refreshed": "Read again",
  "joya.set.tabRoles": "Role names",
  "joya.set.rolesIntro": "Allegro writes roles in words (מלצר, פס חם…). Choose the Joya role each name counts as. Hours with a name that has no Joya role are not counted for any role.",
  "joya.set.roleEmployees": "{n} employees in Allegro",
  "joya.set.noJoyaRole": "— no Joya role —",
  "joya.set.apiUrl": "API address",
};
